<p-password #confirmPassword="ngModel" [(ngModel)]="confirmationPassword" (ngModelChange)="checkValidity(confirmPassword)" autocomplete="off"
    id="confirmPwd" [feedback]="false" [ngClass]="{'ng-invalid ng-dirty' : (!confirmationPassword || confirmationPassword.length == 0) && (submitAttempt || confirmPassword.dirty ||confirmPassword.touched) ||
!(!confirmationPassword || confirmationPassword.length == 0) && (password != confirmationPassword) }"
    placeholder="{{'mot_de_passe_oublier.new_password.labels.confirm_password'|translate}}"
    [toggleMask]="true"></p-password>
<small
    *ngIf="(!confirmationPassword || confirmationPassword.length == 0) && (submitAttempt || confirmPassword.dirty ||confirmPassword.touched)"
    class="p-error">
    {{'mot_de_passe_oublier.errors.champ_obligatoire' | translate}}
</small>
<small *ngIf="!(!confirmationPassword || confirmationPassword.length == 0) && (password != confirmationPassword)"
    class="text-red-500">
    {{'mot_de_passe_oublier.errors.not_matched_password' | translate}}
</small>